import { Platform } from 'react-native'
import { version } from 'APP/../package.json'

const clientIdentifier = `ma-${Platform.OS}-${version}`.toLowerCase()

export const serviceHeaders = {
  'X-Client-Identifier': clientIdentifier,
}
